import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import tagApi from '../../api/tag.api';
import { EComponent } from '../../models/base';
import { ITag } from '../../models/tag.model';

type Props = {
  value?: string | null;
  onChange?: (value: ITag | null) => void;
  component?: EComponent;
};

const TopicSelect = (props: Props) => {
  const [dropdownItems, setDropdownItems] = useState<ITag[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await tagApi.getAll(props.component);

      setDropdownItems(res.data);
    } catch (error) {
      console.error('Error fetching dropdown items:', error);
    } finally {
      setLoading(false);
    }
  }, [props.component]);

  useEffect(() => {
    // Simulate initial load or trigger load on component mount
    fetchData();
  }, [fetchData]);

  return (
    <FormControl fullWidth>
      <InputLabel>Investor</InputLabel>
      <Select
        size="small"
        label="Investor"
        value={props.value || 'no-value'}
        onChange={(e) => {
          if (e.target.value === 'no-value') {
            props.onChange?.(null);
          }
          const item = dropdownItems.find((i) => i.id === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          if (selected === 'no-value') {
            return 'Select an item';
          }
          const item = dropdownItems.find((i) => i.id === selected);

          return item?.name || 'Select an item';
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : (
          <MenuItem key={'empty'} value={'no-value'} sx={{ color: 'gray' }}>
            Empty
          </MenuItem>
        )}
        {!loading &&
          dropdownItems.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default TopicSelect;
